'use strict';

var index = require('./signup/index.js');
var index$1 = require('./dashboard/index.js');
var index$3 = require('./gadget/index.js');
var index$2 = require('./landing_page/index.js');

var signup = Object.assign({}, index);
var dashboard = Object.assign({}, index$1);
var landing_page = Object.assign({}, index$2);
var gadget = Object.assign({}, index$3);
var eventSchemas = {
  signup: signup,
  dashboard: dashboard,
  landing_page: landing_page,
  gadget: gadget
};
var eventSchemas$1 = eventSchemas;

module.exports = eventSchemas$1;
//# sourceMappingURL=index.js.map
